<img  data-qa="test-logo-image" [height]="logoHeight" [src]="logoImage" />